  <div class="container-fluid sell_dash">
        <div class="wrapper">
            <div class="row">
              <app-sidemenu></app-sidemenu>
          <section class="right">
                   <app-sellheader></app-sellheader>
						<div class="right-middle-term-condition row justify-content-center">
							<div class="col-md-10 col-10">
								<div class="card">
									<div class="card-body row">
										<div class="text_term">
											<div class="mb-1">You can upload any enterprise-certified or self-owned asset or derived asset for selling on DataPitcher platform. You needs to upload actual certified asset, preview asset (atleast 100 records or some sample snippet) and some other requested information. Please note that your asset would be hosted on our secured AWS S3 bucket.</div>
                                             <div class="my-1">For on-demand support services like Data Clean-up, anonymization of sensitive or personal data, customized algorithm or ML services:<a href="www.datapitcher.com/dataservices" target="_blank"> Data Services</a></div>
                                             <div class="mt-1">Since sharing data encompass security, privacy & legal issues, so, we request you to understand data classification & data compliance first or talk to our experts:<a href="www.datapitcher.com/compliances" target="_blank"> Data Compliances</a>
                                          </div>
										</div>
										<div class="checkbox-left">
											<label>
												<input type="checkbox" class="assetCheckboxInput">
											</label>
											<p>I am certified owner of assets or derived assets and hereby confirm that I have all necessary rights to offer this asset to third parties, that the asset does not contain information collected illicitly or whose disclosure is likely to breach the rights of third parties.</p>
										</div>
										<div class="right-button">
											<button class="assetButton btn" (click)="getCheckboxInput()">Next</button>
										</div>
									</div>
								</div>
							</div>
						</div>
</section>
	<!-- begin::Sticky Toolbar -->
				<app-stickytoolbar></app-stickytoolbar>
		      <!-- end::Sticky Toolbar -->
</div>
</div>
</div>


